import { createContext, useContext } from "react";
export const FormDenseContext = createContext(false);
export function useControlSize(size) {
    const dense = useContext(FormDenseContext);
    return size !== null && size !== void 0 ? size : (dense ? "small" : "medium");
}
//# sourceMappingURL=formDense.js.map